import { faPlusSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ErrorMessage, FieldArray } from "formik";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import {
  placeholderNoOptions,
  placeholderSelectSimple,
} from "../../../../shared/helpers/placeHolders";
import {
  validateLanguage,
  validateSpokenLevel,
  validateWrittenLevel,
} from "../../../../shared/helpers/validateFields";
import { ICandidateLanguage } from "../../../../shared/model/candidate-language.model";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { newLanguage } from "../../PostulateModel";
import { languageEnum } from "../../../../shared/selectors/languageEnum";
import { to_ISelect_Enum } from "../../../../shared/mutator/dataTransformSelect";
import { languageLevelEnum } from "../../../../shared/selectors/languageLevelEnum";
import { customStyles } from "../custom-selector-styles";
const animatedComponents = makeAnimated();
interface IProps {
  formik: any;
  showErrorsInputs: boolean;
  setShowErrorsInputs: (data: boolean) => void;
}
export const Language = (props: IProps) => {
  const { formik, showErrorsInputs } = props;

  return (
    <>
      {/* Idiomas */}
      <Row className="title-form not-first-title">Idioma</Row>
      <FieldArray
        name="languages"
        render={(arrayHelpers) => (
          <div>
            {formik.values.languages &&
              formik.values.languages.map(
                (currentValue: ICandidateLanguage, index: number) => (
                  <>
                    {index > 0 && (
                      <Row>
                        &emsp;
                        <hr style={{ zIndex: -1 }}></hr>
                      </Row>
                    )}
                    <Row
                      className="mt-5 animate__animated animate__fadeIn"
                      key={index}
                    >

                      <Col xs={12}>
                        <Row>
                          <Col className="d-flex justify-content-end">
                            <Button
                              className="btn-delete-item"
                              outline
                              onClick={() => {
                                arrayHelpers.remove(index);
                                props.setShowErrorsInputs(false);
                              }} // remove a field from the list
                            >
                              <span className="d-md-inline">
                                <FontAwesomeIcon icon={faTrash} />
                              </span>
                            </Button>
                          </Col>
                        </Row>
                        <Row className="container-inputs-form">
                          <Input
                            type="text"
                            hidden
                            name={`languages[${index}].id`}
                            readOnly
                            value={currentValue.id || "0"}
                          ></Input>
                          <Col>
                            <FormGroup>
                              <Label
                                className={
                                  validateLanguage(
                                    formik,
                                    index,
                                    showErrorsInputs
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                                style={{ zIndex: -1 }}
                              >
                                Idioma*
                              </Label>
                              <Select
                                name={`languages[${index}].language`}
                                placeholder={placeholderSelectSimple()}
                                noOptionsMessage={() => placeholderNoOptions()}
                                components={animatedComponents}
                                options={languageEnum()}
                                value={to_ISelect_Enum(
                                  formik.values.languages[index].language,
                                  languageEnum()
                                )}
                                onChange={async (e: any) => {
                                  formik.setFieldValue(
                                    `languages[${index}].language`,
                                    e.value
                                  );
                                }}
                                onBlur={formik.handleBlur(
                                  `languages[${index}].language`
                                )}
                                className={`select-postulate ${validateLanguage(
                                  formik,
                                  index,
                                  showErrorsInputs
                                )
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                styles={customStyles}
                                maxMenuHeight={250}
                              />
                              {validateLanguage(
                                formik,
                                index,
                                showErrorsInputs
                              ) && (
                                  <div className="invalid-feedback">
                                    {formik.errors?.languages[index].language}
                                  </div>
                                )}
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <Label>Nivel escrito*</Label>
                              <Select
                                name={`languages[${index}].writtenLevel`}
                                placeholder={placeholderSelectSimple()}
                                noOptionsMessage={() => placeholderNoOptions()}
                                components={animatedComponents}
                                options={languageLevelEnum()}
                                value={to_ISelect_Enum(
                                  formik.values.languages[index].writtenLevel,
                                  languageLevelEnum()
                                )}
                                onChange={(e: any) => {
                                  formik.setFieldValue(
                                    `languages[${index}].writtenLevel`,
                                    e.value
                                  );
                                }}
                                onBlur={formik.handleBlur(
                                  `languages[${index}].writtenLevel`
                                )}
                                className={`select-postulate`}
                                styles={customStyles}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row className="container-inputs-form">
                          <Col md="6">
                            <FormGroup>
                              <Label>Nivel oral*</Label>
                              <Select
                                name={`languages[${index}].spokenLevel`}
                                placeholder={placeholderSelectSimple()}
                                noOptionsMessage={() => placeholderNoOptions()}
                                components={animatedComponents}
                                options={languageLevelEnum()}
                                value={to_ISelect_Enum(
                                  formik.values.languages[index].spokenLevel,
                                  languageLevelEnum()
                                )}
                                onChange={(e: any) => {
                                  formik.setFieldValue(
                                    `languages[${index}].spokenLevel`,
                                    e.value
                                  );
                                }}
                                onBlur={formik.handleBlur(
                                  `languages[${index}].spokenLevel`
                                )}
                                className={`select-postulate`}
                                styles={customStyles}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                )
              )}
            <Row>
              <Col className="d-flex justify-content-end align-items-end">
                <Button
                  className={`${formik.values.languages &&
                    formik.values.languages.length > 0
                    ? "btn-link"
                    : "btn-link-card"
                    }`}
                  outline
                  onClick={() => arrayHelpers.push(newLanguage)}
                >
                  {formik.values.languages &&
                    formik.values.languages.length > 0 && (
                      <>
                        <span>
                          <FontAwesomeIcon icon={faPlusSquare} />
                        </span>
                      </>
                    )}
                  Agregar idioma
                </Button>
              </Col>
            </Row>
            {formik.values.languages && formik.values.languages.length > 0 && (
              <Row>
                <hr style={{ zIndex: -1 }}></hr>
              </Row>
            )}
          </div>
        )}
      />
    </>
  );
};
